
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#939393","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.406 29.985C7.54 29.948 6 28.563 6 26.803v-7.62C6 17.399 7.583 16 9.482 16h1.842a.91.91 0 110 1.818H9.482c-.941 0-1.664.639-1.664 1.365v7.62c0 .726.723 1.365 1.664 1.365h.833a.91.91 0 01.909.909v3.996l5.347-4.725a.91.91 0 01.602-.227h7.918a.91.91 0 110 1.818h-7.574l-6.6 5.831a.91.91 0 01-1.511-.68v-5.105zm8.284-6.064c-2.039 0-3.69-1.582-3.69-3.536v-8.849C14 9.582 15.651 8 17.69 8h16.616C36.346 8 38 9.584 38 11.54v8.896c0 1.947-1.64 3.526-3.667 3.54v6.138c0 .788-.994 1.182-1.576.625l-7.114-6.818H17.69zM32.388 28v-4.83c0-.484.407-.875.91-.875h.882c1.005 0 1.82-.784 1.82-1.75V11.75c0-.967-.815-1.75-1.82-1.75H17.816C16.812 10 16 10.781 16 11.747v8.747c0 .966.812 1.747 1.816 1.747h8.21c.24 0 .472.092.642.256L32.388 28z"}})])
          )
        }
      }
    